<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Tasas e Impuestos
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div
            v-if="journeyDirection === directionTypeEnum.export && transportMode === transportModeTypeEnum.maritime"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="taxesAndFees.hasDGARateOrAgricultureRate"
                class="uk-checkbox"
                type="checkbox"
              > Tasa DGA / Agricultura
            </label>
          </div>

          <div
            v-if="journeyDirection === directionTypeEnum.export"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="taxesAndFees.originCertificatesIssuance"
                class="uk-checkbox"
                type="checkbox"
              >  Emisión Certificados de Origen
            </label>
          </div>

          <div
            v-if="journeyDirection === directionTypeEnum.import"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="taxesAndFees.itbisImports"
                class="uk-checkbox"
                type="checkbox"
                @change="taxesAndFees.gravamen = null"
              > ITBIS Importaciones
            </label>
          </div>

          <div
            v-if="taxesAndFees.itbisImports"
            class="uk-flex uk-margin InputColumn"
          >
            <label class="uk-margin-right uk-flex uk-flex-middle">
              Introduzca el Gravamen Aduanal para su Envío
            </label>
            <input
              id="quantity"
              v-model="taxesAndFees.gravamen"
              name="quantity"
              min="0"
              max="9999999"
              class="uk-input uk-width-medium filterInputWidth"
              type="number"
              @keydown="$helperPlugin.onlyNumber($event)"
            >
          </div>

          <div
            v-if="journeyDirection === directionTypeEnum.import"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="taxesAndFees.selectiveConsumptionTax"
                class="uk-checkbox"
                type="checkbox"
                @change="taxesAndFees.selectiveConsumptionTaxValue = null"
              >  Impuestos Selectivo al Consumo
            </label>
          </div>

          <div
            v-if="taxesAndFees.selectiveConsumptionTax"
            class="uk-flex uk-margin InputColumn"
          >
            <label class="uk-margin-right uk-flex uk-flex-middle">
              Introduzcan el valor a pagar
            </label>
            <div class="uk-flex isWidth">
              <label class="uk-margin-right uk-flex uk-flex-column isWidth">
                <input
                  id="quantity"
                  v-model="taxesAndFees.selectiveConsumptionTaxValue"
                  name="quantity"
                  min="0"
                  max="9999999"
                  class="uk-input uk-width-medium filterInputWidth"
                  type="number"
                  @keydown="$helperPlugin.onlyDecimal($event)"
                >
                <a
                  class="uk-link"
                  target="_blank "
                  :href="link"
                > Para más información ir Impuesto Selectivo Consumo</a>
              </label>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { directionTypeEnum, transportModeTypeEnum } from '../../../types'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      directionTypeEnum,
      transportModeTypeEnum,
      taxesAndFees: {
        hasDGARateOrAgricultureRate: null,
        originCertificatesIssuance: null,
        itbisImports: null,
        selectiveConsumptionTax: null,
        gravamen: null,
        selectiveConsumptionTaxValue: null
      },
      link: 'https://dgii.gov.do/cicloContribuyente/obligacionesTributarias/principalesImpuestos/Paginas/impuestoSelectivoConsumo.aspx'
    }
  },
  computed: {
    ...mapGetters([
      'taxesAndFeesStore',
      'journeyDirection',
      'transportMode'
    ])
  },

  watch: {
    taxesAndFees: {
      handler: function (newVal) {
        this.$store.commit('setTaxesAndFees', newVal)
      },
      deep: true
    }
  },

  mounted () {
    this.taxesAndFees = { ...this.taxesAndFeesStore }
  }

}
</script>

<style scoped>

section{
  padding: 10px;
  width: 100%;
}
.container-section{
  padding: 10px 40px;
}

.sub-container{
  min-height: 450px;
}
.title{
  font-weight: 600;
  margin-bottom: 10px;
}
.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}
.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}

.items{
  margin-bottom: 30px ;
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
 .container-section{
    padding: 10px 20px;
  }
  .InputColumn {
   display: flex;
   flex-direction: column;
   width: 95%;
   margin: 10px 0 !important;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
.opt{
    font-size: 10px;
  }
}

 @media screen and (max-width: 450px){

.filterInputWidth{
  min-width: 200px;
  width: 100%;
  padding-left: 3px;
}

.isWidth {
  margin: 10px 0 !important;
width: 100%;
}

}

</style>
